<template>
  <div>
    <headerNav :arrow="arrow" title="缴纳保证金" />

    <div class="main-div">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          padding: 20px;
          border-bottom: 1px solid #eee;
          margin: 0 20px 20px 20px;
          color: #4b4b4b;
        "
      >
        {{ abp.userInfo.memberLevelModel.name }}
      </h2>
      <div
        style="
          border: 1px solid #f77b04;
          border-radius: 10px;
          width: 150px;
          text-align: center;
          margin: 0 auto;
          padding: 20px 10px;
        "
      >
        <img src="../../assets/images/earnestmoney.png" />
        <div
          style="
            margin: 10px;
            color: #4b4b4b;
            font-size: 20px;
            font-weight: bold;
          "
        >
          ￥{{ earnestMoney }}元
        </div>
        <div>保证金</div>
      </div>
      <div
        style="border-bottom: 1px solid #eee; margin: 20px; height: 1px"
      ></div>
      <div
        style="
          color: #b1b1b1;
          margin: 20px;
          line-height: 0.6rem;
          font-size: 0.3rem;
        "
      >
        提交保证金是为了保市场的长远发展。如代理有出现乱价或其他违规情况,则一律按照我司规章制度处罚与扣除。如果代理因个人原因申请退出,则在非特殊况下。将于申请日起一个月后退还至个人信账户零钱上
      </div>
      <van-form @submit="onSubmit">
        <div style="margin: 16px">
          <van-button
            :color="$abctheme.basecolor"
            round
            block
            type="info"
            native-type="submit"
            >确认缴纳</van-button
          >
        </div>
        <div style="margin: 16px">
          <van-button round block type="default" @click="logout"
            >退出</van-button
          >
        </div>
      </van-form>
    </div>
    <!-- <div class="mian">
        <div class="mian-yy" :style="{ color: $abctheme.basecolor }">￥</div>
        <div class="mian-tit" :style="{ color: $abctheme.basecolor }">
            我的保证金
        </div>
        <van-form @submit="onSubmit">
            <van-field v-model="earnestMoney" label="缴纳金额" :readonly="true" />
            <div style="margin: 16px">
                <van-button round block type="info" native-type="submit">确认</van-button>
            </div>
            <div style="margin: 16px">
                <van-button round block type="danger" @click="logout">退出</van-button>
            </div>
        </van-form>
    </div> -->
  </div>
</template>

<script>
import AppConsts from '../../config/appconst';
export default {
  data() {
    return {
      earnestMoney: 0,
      wxopenid: "",
      arrow: false,
    };
  },
  methods: {
    onSubmit() {
      this.ajax
        .post(
          "/api/services/app/PhoneAccount/PayEarnestMoney?wxopenid=" +
            this.wxopenid
        )
        .then((x) => {
          let wxpaydata = JSON.parse(x.result);
          console.log(wxpaydata);
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
            location.href = wxpaydata.mweb_url;
          } else {
            this.onBridgeReady(wxpaydata);
          }
        });
    },
    onBridgeReady(params) {
      let that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: params.appid, //公众号名称，由商户传入
          timeStamp: params.timeStamp + "", //时间戳，自1970年以来的秒数
          nonceStr: params.nonceStr, //随机串
          package: params.package,
          signType: params.signType, //微信签名方式：
          paySign: params.sign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            location.reload();
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    logout() {
      this.abp.auth.clearToken();
      location.reload();
    },
  },
  created() {
    this.abp.userInfo.openid =
      this.abp.userInfo.openid || localStorage.getItem("openid");
      this.wxopenid=this.abp.userInfo.openid;
    if (!this.abp.userInfo.openid) {
      var code = this.getQueryVariable("code");
      if (code) {
        this.ajax
          .post("/api/services/app/PhoneAccount/WxOAuth?code=" + code)
          .then((x) => {
            this.wxopenid = x.result;
            localStorage.setItem("openid", this.wxopenid);
          });
      } else {
        if (process.env.NODE_ENV == "production") {
          location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+AppConsts.wxappid+"&redirect_uri=http%3A%2F%2f" +
            location.host +
            "%2F%23%2Fpayearnestmoney" +
            "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
          return;
        }
      }
    }

    this.earnestMoney = (
      this.abp.userInfo.memberLevelModel.earnestMoney -
      this.abp.userInfo.earnestMoney
    ).toFixed(2);
  },
};
</script>

<style lang="scss" scoped>
.main-div {
  background: #fff;
  border-radius: 30px;
  color: #b1b1b1;
  margin-top: 0;
}
.mian {
  position: relative;
  background-color: rgb(179, 197, 135);
  border-radius: 4px;
  box-shadow: 2px 2px 4px #bbb;
  text-align: center;
  padding: 50px 0;
  font-size: 25px;
  margin: 80px 10px 80px 10px;
}

.mian-yy {
  font-size: 100px;
}

.mian-tit {
  font-size: 28px;
}

.van-form {
  margin-left: 10px;
  margin-right: 10px;
}

.van-cell {
  border-radius: 3px;
}
</style>
